export default [
  '/about',
  '/access_data',
  '/analyze_data',
  '/support'
];
